import styled, { css } from 'styled-components';
import { getMargins, getTypographyStyles, SYS_SIZE_FIXED_50, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_75, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_25, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_50, SEM_TYPOGRAPHY_ACTION_LG_LABEL, SEM_TYPOGRAPHY_ACTION_SM_LABEL, SEM_OPACITY_ACTION_100_PCT, SEM_OPACITY_ACTION_20_PCT } from '@oneaudi/unified-web-common';
import { Icon } from '../icon/index.js';
const indicator = (size) => css `
  content: '';
  display: block;
  position: absolute;
  bottom: ${SYS_SPACE_FIXED_50};
  height: ${size === 'md' ? SYS_SIZE_FIXED_75 : SYS_SIZE_FIXED_50};
  width: calc(100% - 2 * ${SYS_SPACE_FIXED_50});
  opacity: ${SEM_OPACITY_ACTION_20_PCT};
  // TODO: add transition tokens
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, opacity;
`;
const variantStyles = (variant) => css `
  color: ${(props) => props.theme.cmp.color.action.iconButton[variant].foreground.text.default};

  ${StyledIconContainer} {
    color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.default};
    background-color: ${(props) => props.theme.sem.color.action[variant].surface.fill.default};

    ${variant === 'secondary' &&
    css `
      box-shadow: inset 0 0 0 ${SYS_SIZE_FIXED_25}
        ${(props) => props.theme.sem.color.action.secondary.surface.stroke.default};
    `}

    &::before {
      background-color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.default};
    }
  }

  &:hover {
    color: ${(props) => props.theme.cmp.color.action.iconButton[variant].foreground.text.hover};

    ${StyledIconContainer} {
      background-color: ${(props) => props.theme.sem.color.action[variant].surface.fill.hover};
      color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.hover};

      ${variant === 'secondary' &&
    css `
        box-shadow: inset 0 0 0 ${SYS_SIZE_FIXED_25}
          ${(props) => props.theme.sem.color.action.secondary.surface.stroke.hover};
      `}

      &::before {
        background-color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.hover};
      }
    }
  }

  &:active {
    color: ${(props) => props.theme.cmp.color.action.iconButton[variant].foreground.text.pressed};

    ${StyledIconContainer} {
      background-color: ${(props) => props.theme.sem.color.action[variant].surface.fill.pressed};
      color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.pressed};

      &::before {
        background-color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.pressed};
      }
    }
  }

  ${StyledInput}:disabled + & {
    cursor: not-allowed;
    color: ${(props) => props.theme.cmp.color.action.iconButton[variant].foreground.text
    .disabled};

    ${StyledIconContainer} {
      cursor: not-allowed;
      background-color: ${(props) => props.theme.sem.color.action[variant].surface.fill.disabled};
      color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.disabled};

      ${variant === 'secondary' &&
    css `
        box-shadow: inset 0 0 0 ${SYS_SIZE_FIXED_25}
          ${(props) => props.theme.sem.color.action.secondary.surface.stroke.disabled};
      `}

      &::before {
        background-color: ${(props) => props.theme.sem.color.action[variant].foreground.icon.disabled};
      }
    }
  }
`;
export const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: inline-flex;
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
`;
export const StyledIconContainer = styled.span `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${(props) => props.size === 'sm' ? SYS_SIZE_FIXED_1200 : SYS_SIZE_FIXED_1400};
  height: ${(props) => props.size === 'sm' ? SYS_SIZE_FIXED_1200 : SYS_SIZE_FIXED_1400};
  box-sizing: border-box;
  // TODO: add transition tokens
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, opacity;

  ${(props) => !props.iconOnly &&
    css `
      &::before {
        ${indicator(props.size ?? 'md')};
      }
    `}
`;
export const StyledLabel = styled.label `
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SYS_SPACE_FIXED_100};
  // TODO: add transition tokens
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, opacity;

  ${(props) => props.size === 'md'
    ? getTypographyStyles(SEM_TYPOGRAPHY_ACTION_LG_LABEL)
    : getTypographyStyles(SEM_TYPOGRAPHY_ACTION_SM_LABEL)};

  ${StyledInput}:focus + & ${StyledIconContainer} {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
  }

  ${StyledInput}:focus:not(:focus-visible) + & ${StyledIconContainer} {
    outline: none;
  }

  ${StyledInput}:checked + & ${StyledIconContainer}::before {
    opacity: ${SEM_OPACITY_ACTION_100_PCT};
  }

  ${(props) => props.variant && variantStyles(props.variant)};
`;
export const StyledIcon = styled(Icon) ``;
export const StyledVisuallyHiddenLabel = styled.span `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
//# sourceMappingURL=index.styles.js.map